// Runtime lists of the primitive unions, each checked exhaustive at compile time.
import type { AgeGroup, Metric, NeedId, RationResource, Resource, Season } from './types';

type Exhaustive<U, L extends readonly U[]> = Exclude<U, L[number]> extends never ? L : never;

function list<U>() {
  return <const L extends readonly U[]>(items: Exhaustive<U, L>): readonly U[] => items;
}

export const SEASONS = list<Season>()(['spring', 'summer', 'autumn', 'winter']);
export const RESOURCES = list<Resource>()([
  'food',
  'water',
  'wood',
  'stone',
  'tools',
  'medicine',
  'cloth',
  'fibre',
]);
export const RATION_RESOURCES = list<RationResource>()(['food', 'water', 'warmth', 'medicine']);
export const NEEDS = list<NeedId>()([
  'food',
  'water',
  'shelter',
  'warmth',
  'healthCare',
  'safety',
  'belonging',
]);
export const AGE_GROUPS = list<AgeGroup>()(['child', 'adult', 'elder']);
export const METRICS = list<Metric>()([
  'population',
  'adults',
  'children',
  'elders',
  'food',
  'water',
  'wood',
  'stone',
  'tools',
  'medicine',
  'cloth',
  'trust',
  'happiness',
  'fragility',
  'gini',
  'giniBeds',
  'literacy',
  'births',
  'deaths',
  'sick',
]);
